module.exports = __webpack_public_path__ + "static/media/fairy-male.cfcb3ae7.png";